import type { SVGProps } from "react";

export default function ChartsIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M18.3337 18.5098H1.66699"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M17.5 18.51V12.26C17.5 11.5697 16.9403 11.01 16.25 11.01H13.75C13.0597 11.01 12.5 11.5697 12.5 12.26V18.51"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M12.5005 18.5102V4.34351C12.5005 3.165 12.5005 2.57574 12.1344 2.20962C11.7682 1.84351 11.179 1.84351 10.0005 1.84351C8.82199 1.84351 8.23272 1.84351 7.8666 2.20962C7.50049 2.57574 7.50049 3.165 7.50049 4.34351V18.5102"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M7.5 18.5104V8.09375C7.5 7.40339 6.94036 6.84375 6.25 6.84375H3.75C3.05964 6.84375 2.5 7.40339 2.5 8.09375V18.5104"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
